<template>
  <div class="rank-chart">
    <ChartBox :option="option" />
  </div>
</template>

<script setup>
import { computed } from "vue";
import ChartBox from "@/components/xiaofeiTradeData/ChartBox.vue";
import { priceProducts, priceSpread } from "./priceData";

const rankData = [...priceProducts]
  .map((product) => ({ name: product.name, value: Number(priceSpread(product).toFixed(2)) }))
  .sort((a, b) => b.value - a.value)
  .slice(0, 10)
  .reverse();

const names = rankData.map((item) => item.name);
const values = rankData.map((item) => item.value);

const option = computed(() => ({
  grid: { top: 22, left: 166, right: 66, bottom: 42 },
  tooltip: { trigger: "axis", textStyle: { fontSize: 22 } },
  xAxis: {
    type: "value",
    axisLabel: { color: "#bfe7ff", fontSize: 20 },
    splitLine: { lineStyle: { color: "rgba(116, 173, 225, .12)" } },
  },
  yAxis: {
    type: "category",
    data: names,
    axisTick: { show: false },
    axisLine: { show: false },
    axisLabel: { color: "#e6f6ff", fontSize: 18, fontWeight: "bold" },
  },
  series: [
    {
      type: "bar",
      barWidth: 18,
      data: values,
      label: {
        show: true,
        position: "right",
        color: "#dff7ff",
        fontSize: 18,
        fontWeight: "bold",
        formatter: "{c}元",
      },
      itemStyle: {
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [
            { offset: 0, color: "#1d72ff" },
            { offset: 1, color: "#29d7ff" },
          ],
        },
      },
    },
  ],
}));
</script>

<style scoped>
.rank-chart {
  height: 100%;
}
</style>
